import { Button, Col, Form, Input, Row, Select, Space, Spin } from 'antd'

import CustomTextArea from '../../components/CustomTextarea'
import Uploadfiles from '../../modules/uploadfiles'
import { useSetupHook } from './hooks'
import styles from './styles.module.scss'
import { regexDict } from '../../tools/regex'
import { formatStr, invoicingType } from '../../tools/util'
import InvoiceOrderInfo from '../../modules/invoiceOrderInfo'

const formLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 16 },
}
export default function AddInvoice() {
  const {
    form,
    state,
    handleUploadfilesChange,
    handleClosePage,
    handleSubmit,
    handleFormValueChange,
  } = useSetupHook()
  const {
    uploadFilesList,
    isPageLoading,
    isSubmitButtonLoading,
    orderData,
    materialData,
  } = state

  const isRule = form.getFieldValue('orderInvoiceEnums') !== 'NORMAL' // NOMAL为普通发票
  return (
    <div className={styles['container']}>
      <Spin spinning={isPageLoading}>
        <div className={styles['top-panel']}>
          <InvoiceOrderInfo materialData={materialData} orderData={orderData} />
        </div>
        <div className={styles['form-container']}>
          <Form
            form={form}
            {...formLayout}
            onValuesChange={handleFormValueChange}
            style={{ marginBottom: '100px' }}
          >
            <Row gutter={200}>
              <Col span={12}>
                <Row className={styles['title']}>开票信息</Row>
                <Form.Item
                  label="发票类型"
                  name="orderInvoiceEnums"
                  required
                  initialValue={'NORMAL'}
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Select>
                    {invoicingType.map((item) => {
                      return (
                        <Select.Option key={item.value} value={item.value}>
                          {item.name}
                        </Select.Option>
                      )
                    })}
                  </Select>
                </Form.Item>
                <Form.Item
                  label="发票抬头"
                  name="title"
                  required
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input placeholder="请输入" maxLength={140}></Input>
                </Form.Item>
                <Form.Item
                  label="税号"
                  name="taxNumber"
                  required
                  rules={[
                    {
                      required: true,
                    },
                    {
                      pattern: /^[\dA-NP-Z]*$/,
                      message: '只允许输入数字、大写字母,不允许输入字母O',
                    },
                  ]}
                >
                  <Input placeholder="请输入" maxLength={20}></Input>
                </Form.Item>
                <Form.Item
                  label="开户银行"
                  name="bankName"
                  required={isRule}
                  rules={[
                    {
                      required: isRule,
                    },
                  ]}
                >
                  <Input placeholder="请输入" maxLength={140}></Input>
                </Form.Item>
                <Form.Item
                  label="银行账户"
                  name="bankAccount"
                  required={isRule}
                  rules={[
                    {
                      required: isRule,
                    },
                  ]}
                  getValueFromEvent={(e) => {
                    // eslint-disable-next-line
                    return formatStr(e.target.value, 'bankAccount')
                  }}
                >
                  <Input placeholder="请输入" maxLength={20}></Input>
                </Form.Item>
                <Form.Item
                  label="电话"
                  name="mobile"
                  required={isRule}
                  rules={[
                    {
                      required: isRule,
                    },
                    regexDict.mobileSymbol,
                  ]}
                >
                  <Input placeholder="请输入" maxLength={20}></Input>
                </Form.Item>
                <Form.Item
                  label="地址"
                  name="address"
                  required={isRule}
                  rules={[
                    {
                      required: isRule,
                    },
                  ]}
                >
                  <Input placeholder="请输入" maxLength={140}></Input>
                </Form.Item>
                <Form.Item
                  label="发票备注信息"
                  name="content"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <CustomTextArea
                    placeholder="填发票需要备注的信息，例如客户订单号，若无备注要求，请填写无"
                    maxLength={500}
                  ></CustomTextArea>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Row className={styles['title']}>其他信息</Row>
                <Form.Item
                  label="邮箱"
                  name="mail"
                  rules={[
                    {
                      required: true,
                    },
                    regexDict.emialCheck,
                  ]}
                >
                  <Input placeholder="请输入" maxLength={50}></Input>
                </Form.Item>
                <Form.Item label="收件人" name="receiveMan">
                  <Input placeholder="请输入" maxLength={20}></Input>
                </Form.Item>
                <Form.Item label="联系电话" name="receiveMobile">
                  <Input placeholder="请输入" maxLength={20}></Input>
                </Form.Item>
                <Form.Item label="收件地址" name="receiveAddress">
                  <Input placeholder="请输入" maxLength={50}></Input>
                </Form.Item>
                <Form.Item label="其他备注" name="remark">
                  <CustomTextArea
                    placeholder="填写是否要写购销方银行信息，是否有订单要合并开票等其它要求。"
                    maxLength={500}
                  ></CustomTextArea>
                </Form.Item>
                <Form.Item label="附件" name="files">
                  <Uploadfiles
                    title="选择文件"
                    type="orderOtherFile"
                    code={orderData[0]?.id}
                    dataSource={uploadFilesList}
                    onChange={handleUploadfilesChange}
                    accept=".jpg,.png,.jpeg,.pdf"
                    maxCount={10}
                    directlyDelete
                    notSaveInBase={orderData.length > 1}
                  />
                  <Row>
                    <span style={{ color: '#919191', fontSize: '12px' }}>
                      支持jpg、png、jpeg、pdf
                    </span>
                  </Row>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <div className={styles['bottom-buttons-container']}>
            <Space>
              <Button onClick={handleClosePage}>取消</Button>
              <Button
                type="primary"
                onClick={handleSubmit}
                className={styles['button-item']}
                loading={isSubmitButtonLoading}
              >
                提交
              </Button>
            </Space>
          </div>
        </div>
      </Spin>
    </div>
  )
}
import { Button, Col, Form, Input, Row, Select, Space, Spin } from 'antd'

import CustomTextArea from '../../components/CustomTextarea'
import Uploadfiles from '../../modules/uploadfiles'
import { useSetupHook } from './hooks'
import styles from './styles.module.scss'
import { regexDict } from '../../tools/regex'
import { formatStr, invoicingType } from '../../tools/util'
import InvoiceOrderInfo from '../../modules/invoiceOrderInfo'

const formLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 16 },
}
export default function AddInvoice() {
  const {
    form,
    state,
    handleUploadfilesChange,
    handleClosePage,
    handleSubmit,
    handleFormValueChange,
  } = useSetupHook()
  const {
    uploadFilesList,
    isPageLoading,
    isSubmitButtonLoading,
    orderData,
    materialData,
  } = state

  const isRule = form.getFieldValue('orderInvoiceEnums') !== 'NORMAL' // NOMAL为普通发票
  return (
    <div className={styles['container']}>
      <Spin spinning={isPageLoading}>
        <div className={styles['top-panel']}>
          <InvoiceOrderInfo materialData={materialData} orderData={orderData} />
        </div>
        <div className={styles['form-container']}>
          <Form
            form={form}
            {...formLayout}
            onValuesChange={handleFormValueChange}
            style={{ marginBottom: '100px' }}
          >
            <Row gutter={200}>
              <Col span={12}>
                <Row className={styles['title']}>开票信息</Row>
                <Form.Item
                  label="发票类型"
                  name="orderInvoiceEnums"
                  required
                  initialValue={'NORMAL'}
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Select>
                    {invoicingType.map((item) => {
                      return (
                        <Select.Option key={item.value} value={item.value}>
                          {item.name}
                        </Select.Option>
                      )
                    })}
                  </Select>
                </Form.Item>
                <Form.Item
                  label="发票抬头"
                  name="title"
                  required
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input placeholder="请输入" maxLength={140}></Input>
                </Form.Item>
                <Form.Item
                  label="税号"
                  name="taxNumber"
                  required
                  rules={[
                    {
                      required: true,
                    },
                    {
                      pattern: /^[\dA-NP-Z]*$/,
                      message: '只允许输入数字、大写字母,不允许输入字母O',
                    },
                  ]}
                >
                  <Input placeholder="请输入" maxLength={20}></Input>
                </Form.Item>
                <Form.Item
                  label="开户银行"
                  name="bankName"
                  required={isRule}
                  rules={[
                    {
                      required: isRule,
                    },
                  ]}
                >
                  <Input placeholder="请输入" maxLength={140}></Input>
                </Form.Item>
                <Form.Item
                  label="银行账户"
                  name="bankAccount"
                  required={isRule}
                  rules={[
                    {
                      required: isRule,
                    },
                  ]}
                  getValueFromEvent={(e) => {
                    // eslint-disable-next-line
                    return formatStr(e.target.value, 'bankAccount')
                  }}
                >
                  <Input placeholder="请输入" maxLength={20}></Input>
                </Form.Item>
                <Form.Item
                  label="电话"
                  name="mobile"
                  required={isRule}
                  rules={[
                    {
                      required: isRule,
                    },
                    regexDict.mobileSymbol,
                  ]}
                >
                  <Input placeholder="请输入" maxLength={20}></Input>
                </Form.Item>
                <Form.Item
                  label="地址"
                  name="address"
                  required={isRule}
                  rules={[
                    {
                      required: isRule,
                    },
                  ]}
                >
                  <Input placeholder="请输入" maxLength={140}></Input>
                </Form.Item>
                <Form.Item
                  label="发票备注信息"
                  name="content"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <CustomTextArea
                    placeholder="填发票需要备注的信息，例如客户订单号，若无备注要求，请填写无"
                    maxLength={500}
                  ></CustomTextArea>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Row className={styles['title']}>其他信息</Row>
                <Form.Item
                  label="邮箱"
                  name="mail"
                  rules={[
                    {
                      required: true,
                    },
                    regexDict.emialCheck,
                  ]}
                >
                  <Input placeholder="请输入" maxLength={50}></Input>
                </Form.Item>
                <Form.Item label="收件人" name="receiveMan">
                  <Input placeholder="请输入" maxLength={20}></Input>
                </Form.Item>
                <Form.Item label="联系电话" name="receiveMobile">
                  <Input placeholder="请输入" maxLength={20}></Input>
                </Form.Item>
                <Form.Item label="收件地址" name="receiveAddress">
                  <Input placeholder="请输入" maxLength={50}></Input>
                </Form.Item>
                <Form.Item label="其他备注" name="remark">
                  <CustomTextArea
                    placeholder="填写是否要写购销方银行信息，是否有订单要合并开票等其它要求。"
                    maxLength={500}
                  ></CustomTextArea>
                </Form.Item>
                <Form.Item label="附件" name="files">
                  <Uploadfiles
                    title="选择文件"
                    type="orderOtherFile"
                    code={orderData[0]?.id}
                    dataSource={uploadFilesList}
                    onChange={handleUploadfilesChange}
                    accept=".jpg,.png,.jpeg,.pdf"
                    maxCount={10}
                    directlyDelete
                    notSaveInBase={orderData.length > 1}
                  />
                  <Row>
                    <span style={{ color: '#919191', fontSize: '12px' }}>
                      支持jpg、png、jpeg、pdf
                    </span>
                  </Row>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <div className={styles['bottom-buttons-container']}>
            <Space>
              <Button onClick={handleClosePage}>取消</Button>
              <Button
                type="primary"
                onClick={handleSubmit}
                className={styles['button-item']}
                loading={isSubmitButtonLoading}
              >
                提交
              </Button>
            </Space>
          </div>
        </div>
      </Spin>
    </div>
  )
}
